import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, TranslocoModule, RouterLinkActive],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent {
  @Output() menuItemClick = new EventEmitter<void>();
  @Output() closeMenu = new EventEmitter<void>();

  // `icon` is a FontAwesome class suffix (e.g. 'fa-user') rendered via
  // <i class="fas {{ item.icon }}"></i>.
  menuItems = [
    {
      label: 'side-menu.profile',
      icon: 'fa-user',
      route: 'profile'
    },
    {
      label: 'side-menu.jobs',
      icon: 'fa-briefcase',
      route: 'jobs'
    },
    {
      label: 'side-menu.settings',
      icon: 'fa-cog',
      route: 'settings'
    }
  ];

  onMenuItemClick(): void {
    this.menuItemClick.emit();
  }

  onCloseClick(): void {
    this.closeMenu.emit();
  }
}